import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom'; //Redirect
// import { Container } from 'reactstrap';
import PropTypes from 'prop-types';

import {
	AppFooter,
	AppHeader,
} from '@coreui/react';
// sidebar nav config
// routes config
import routes from '../../routes';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import ParadigmaHeaderMenu from '../../components/ParadigmaHeaderMenu';

import Sidebar from '../../components/Sidebar';

import './styles.scss';

import CartProvider from "../../components/ParadigmaCartProvider";
import LoginProvider from "../../components/ParadigmaLoginProvider";
import CompareProvider from '../../components/CompareProvider/CompareProvider.js';

import api from "../../api";
import functions from "../../api/functions.js";

import { LoginContext } from "../../components/ParadigmaLoginProvider";

class DefaultLayout extends Component {
	constructor() {
		super();
		this.state = {
			menuBackdrop: false,
			Menues: [],
			searchStr: "",
			isSticky: false,
		}
	}

	static propTypes = {
		children: PropTypes.node,
		Configuracion: PropTypes.object,
	}

	componentDidMount() {
		this.loadMenues();
		window.addEventListener('scroll', this.handleScroll);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	loadMenues() {
		functions.get(api.api.menu, null, null, null, (data) => {
			this.setState({ Menues: data.data });
		});
	}

	toggleMenuBackdrop(show) {
		this.setState((prevState) => {
			prevState.menuBackdrop = show;
			return prevState;
		});
	}

	handleScroll = () => {
		if (window.scrollY > 0) {
			this.setState({ isSticky: true });
		} else {
			this.setState({ isSticky: false });
		}
	}
	render() {
		const { Configuracion } = this.props;
		const { menuBackdrop, Menues, searchStr, isSticky  } = this.state;
		const setSearchStr = (value) => this.setState({searchStr:value});
		return (
			<CompareProvider>
			<LoginProvider>
				<CartProvider>

					<div className="app">
						{/* <div className="topHeader d-block">
							<div className="container">
								<div className="row">
									<div className="col-12 col-sm-6 header-telefono-left">
										<p className="text-center text-md-left">
											<span className="topHeader__tel">
												<a href="tel:+5492914514000">(+54) 291 451 4000</a>
											</span>
											/
											<a href="tel:+5492914539497">453-9497</a>
											/
											<a href="tel:+5492914528750">452-8750</a>
											/
											<a className="topHeader__email" href="mailto:ventas@darsur.com.ar">ventas@darsur.com.ar</a></p>
									</div>
									<div className="col-12 col-sm-6 header-direccion-right">
										<p className="text-center text-md-right"><span className="ml-5 d-sm-inline-block topHeader__pin"> <strong>Chiclana 645/9</strong>  |  Bahía Blanca | Buenos Aires, Argentina</span></p>
									</div>
								</div>
							</div>
						</div> */}

						<AppHeader className={`esige-header ${isSticky ? 'sticky' : ''}`}>
							<div className="container-fluid my-2 mb-lg-0 py-2">
								<DefaultHeader searchStr={searchStr} updateSearchStr={setSearchStr} Configuracion={Configuracion} />
							</div>
						</AppHeader>

						{Menues.length > 0 &&
							<div className="esige-menu">
								<div className={"container"}>
									<ParadigmaHeaderMenu
										Menues={Menues}
										onMenuWillOpen={() => this.toggleMenuBackdrop(true)}
										onMenuWillClose={() => this.toggleMenuBackdrop(false)}
									/>
								</div>
							</div>
						}

						<div className="app-body">
							<main className="main">
								{/*<Container fluid>*/}
									<Switch>
										{routes.filter(x => !x.logged).map((route, idx) => {
											return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
												<route.component {...props} searchStr={searchStr} updateSearchStr={setSearchStr} />
											)} />)
											: (null);
										})}
										<LoginContext.Consumer>
											{({ logged, logout }) => {
												if (logged) {
													return routes.filter(x => x.logged).map((route, idx) => {
														return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
															<route.component {...props} searchStr={searchStr} updateSearchStr={setSearchStr} />
														)} />)
															: (null);
													});
												} else {
													return routes.filter(x => x.logged).map((route, idx) => {
														return <Redirect key={idx} path={route.path} to={"/"} exact={route.exact} />;
													});
												}
											}
											}
										</LoginContext.Consumer>

									</Switch>
								{/*</Container>*/}
							</main>
						</div>

						<DefaultFooter />

						{menuBackdrop && <div className="menu-backdrop"></div>}

					</div>
				</CartProvider>
			</LoginProvider>
			</CompareProvider>
		);
	}
}

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultLayout.js